import { cn } from '@/lib/utils'
import { Wifi, WifiOff, Loader2 } from 'lucide-react'
import { useRecords } from '@/contexts/record-context'

export function SyncStatus() {
  const { offline, syncing } = useRecords()

  return (
    <div className={cn(
      'flex items-center gap-1.5 text-xs',
      offline ? 'text-destructive' : syncing ? 'text-primary' : 'text-green-500'
    )}>
      {syncing ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : offline ? (
        <WifiOff className="h-3.5 w-3.5" />
      ) : (
        <Wifi className="h-3.5 w-3.5" />
      )}
      <span>{syncing ? '同步中' : offline ? '离线' : '在线'}</span>
    </div>
  )
}
